import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {
    ThinAddIcon,
    ThinEditIcon,
    ThinFilterIcon, ThinTrashIcon,
    ThinVisibilityOffIcon,
    ThinVisibilityOnIcon
} from "../../../components/icons/material-icons";
import {AdminsCenterFilterClassesModal} from "./filter-visibility-modal";
import {CurrencyFormat} from "../../../components/techaran/money";
import {Link, useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {AdminsAddEditCenterClassModal} from "./add-edit-center-class";
import {RemoveModal} from "../../../components/template/remove-modal";

interface centerClassInterface {
    id: number,
    title: string,
    desc: string,
    img: string,
    max: number,
    teacher: string,
    price: number,
    signup: number,
    approved: number,
    hidden: 0 | 1,
    isWorkshop:0|1,
    allowedClasses:{
        id:number,
        title:string,
    }[]|null,
    expiresAt:string,
    hasExpiration:0|1,
    sessionCount:number,
    presentedAt:string, // datetime
}

export const AdminCenterScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as centerClassInterface[]);
    const [onlyShow, setOnlyShow] = useState('shown' as 'all' | 'shown' | 'hide');
    const [canAddEdit,setCanAddEdit] = useState(false);
    const navigate = useNavigate();
    const fetchList = (show: 'all' | 'shown' | 'hide') => {
        PostJSON(
            Apis.server + '/core/admins/center/class/list',
            {
                show: show,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: null | centerClassInterface[],
                canAdd:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/',{replace:true});
                    }
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
                setCanAddEdit(d.canAdd);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مرکزعلمی | اتوماسیون شهاب";
        fetchList('shown');
    }, []);
    const [addEdit, setAddEdit] = useState({
        show: false,
        edit: false,
        id: 0,
        title: '',
        desc: '',
        teacher: '',
        price: 0,
        max:0,
        isWorkshop:0,
        allowedClasses:[] as number[],
        expiresAt:'2000-01-01 00:00:00',
        hasExpiration:0,
        sessionCount:0,
        presentedAt:'2000-01-01 00:00:00',
    });
    const [filterModal, setFilterModal] = useState(false);
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    const removeClass = () => {
        // /core/admins/center/class/remove
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مرکز علمی', url: '/admins/center'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>کلاس‌های مرکز علمی</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    <button onClick={() => setFilterModal(true)}>
                                        <ThinFilterIcon/>
                                        <span>{onlyShow === 'shown' ? 'فقط نمایان' : (onlyShow === 'hide' ? 'فقط پنهان' : 'همه موارد')}</span>
                                    </button>
                                    {
                                        canAddEdit ?
                                            <button onClick={() => setAddEdit({
                                                show: true,
                                                edit: false,
                                                id: 0,
                                                title: '',
                                                desc: '',
                                                teacher: '',
                                                price: 0,
                                                max: 0,
                                                isWorkshop: 0,
                                                allowedClasses: [],
                                                expiresAt: '2000-01-01 00:00:00',
                                                hasExpiration: 0,
                                                sessionCount: 0,
                                                presentedAt: '2000-01-01 00:00:00',
                                            })}>
                                                <ThinAddIcon/>
                                                <span>کلاس جدید</span>
                                            </button> : null
                                    }
                                </div>
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>کلاس</th>
                                    <th>مربی</th>
                                    <th>حداکثر پذیرش</th>
                                    <th>تعداد ثبت‌نام</th>
                                    <th>تعداد تاییدشده</th>
                                    <th>وضعیت</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"Ks92kwWwK31" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/center/class/${s.id}`}>
                                                    {s.title}
                                                </Link>
                                            </td>
                                            <td>{s.teacher}</td>
                                            <td>{CurrencyFormat(s.max)}</td>
                                            <td>{CurrencyFormat(s.signup)}</td>
                                            <td>{CurrencyFormat(s.approved)}</td>
                                            <td>{s.hidden === 1 ? 'پنهان' : 'نمایان'}</td>
                                            <td>
                                                <div
                                                    className="d-inline-flex justify-content-center align-items-center"
                                                    style={{gap: 10}}>
                                                    {
                                                        canAddEdit ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => {
                                                                        let lst: number[] = [];
                                                                        const x = {...s};
                                                                        if (x.allowedClasses !== null)
                                                                            x.allowedClasses.forEach(e => {
                                                                                lst.push(e.id);
                                                                            });
                                                                        setAddEdit({
                                                                            show: true,
                                                                            edit: true,
                                                                            id: s.id,
                                                                            title: s.title,
                                                                            desc: s.desc,
                                                                            teacher: s.teacher,
                                                                            price: s.price,
                                                                            max: s.max,
                                                                            isWorkshop: s.isWorkshop,
                                                                            allowedClasses: lst,
                                                                            expiresAt: s.expiresAt,
                                                                            hasExpiration: s.hasExpiration,
                                                                            presentedAt: s.presentedAt,
                                                                            sessionCount: s.sessionCount,
                                                                        });
                                                                    }}>
                                                                <ThinEditIcon/>
                                                                <i>ویرایش</i>
                                                            </button> : null
                                                    }
                                                    <button className="open-tooltip"
                                                            onClick={() => {
                                                                ShowProgressLoading();
                                                                const h = s.hidden === 1 ? 0 : 1;
                                                                PostJSON(
                                                                    Apis.server + "/core/admins/center/class/visibility",
                                                                    {
                                                                        id: s.id,
                                                                        hide: h,
                                                                    },
                                                                    true,
                                                                    (d: {
                                                                        result: string,
                                                                        reason: string,
                                                                    }) => {
                                                                        HideProgressLoading();
                                                                        if (d.result !== 'OK') {
                                                                            if (d.reason === 'login')
                                                                                AuthRedirectAdmins();
                                                                            return;
                                                                        }
                                                                        setList(v => {
                                                                            let x = [...v];
                                                                            const g = x.findIndex(a => a.id === s.id);
                                                                            if (g > -1)
                                                                                x[g].hidden = h;
                                                                            return x;
                                                                        });
                                                                        ShowSnackbar(
                                                                            'وضعیت نمایش کلاس تغییر یافت.',
                                                                            'باشه',
                                                                            5000,
                                                                        );
                                                                    },
                                                                    () => {
                                                                    },
                                                                    AuthRedirectAdmins,
                                                                ).then(void 0);
                                                            }}>
                                                        {s.hidden === 1 ? <ThinVisibilityOnIcon/> :
                                                            <ThinVisibilityOffIcon/>}
                                                        <i>{s.hidden === 1 ? 'نمایان سازی' : 'پنهان شود'}</i>
                                                    </button>
                                                    {
                                                        canAddEdit ?
                                                            <button onClick={() => setRemoveModal({
                                                                title: s.title,
                                                                show: true,
                                                                id: s.id,
                                                            })} className={"open-tooltip"}>
                                                                <ThinTrashIcon/>
                                                                <i>حذف کلاس</i>
                                                            </button> : null
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsCenterFilterClassesModal
                active={filterModal}
                closeHandler={() => setFilterModal(false)}
                onDone={(e: 'all' | 'shown' | 'hide') => {
                    setOnlyShow(e);
                    ShowProgressLoading();
                    fetchList(e);
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
                current={onlyShow}
            />
            <AdminsAddEditCenterClassModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                isEdit={addEdit.edit}
                id={addEdit.id}
                title={addEdit.title}
                desc={addEdit.desc}
                teacher={addEdit.teacher}
                price={addEdit.price}
                onDone={() => {
                    const c = onlyShow;
                    ShowProgressLoading();
                    fetchList(c);
                }}
                maxParticipants={addEdit.max}
                expiresAt={addEdit.expiresAt}
                hasExpiration={addEdit.hasExpiration === 1}
                isWorkshop={addEdit.isWorkshop === 1}
                allowedClasses={addEdit.allowedClasses}
                presentedAt={addEdit.presentedAt}
                sessionCount={addEdit.sessionCount}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف کلاس مرکزعلمی"}
                desc={"آیا مطمئن هستید که می‌خواهید " + removeModal.title + " را حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/center/class/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'کلاس حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList('all');
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};